<template>
  <v-speed-dial
    v-model="fab"
    v-bind="attributes"
    data-has-tooltip="true"
    data-tooltip="Ações suspensas"
    :data-behavior="componentBehavior"
    class="fab-container"
    v-if="!!visibleActions.length"
  >
    <template v-slot:activator>
      <div
        @contextmenu="selectComponentDEV($event, schema.model)"
        :class="[getSelectedDEV && 'dev-selected-component']"
      >
        <v-btn v-model="fab" :color="attributes.color" fab>
          <v-icon v-if="fab">close</v-icon>
          <v-icon v-else>{{ attributes.icon }}</v-icon>
        </v-btn>
      </div>
    </template>

    <template v-for="(action, index) in visibleActions">
      <v-tooltip left :color="action.tooltipColorClass" :key="index" :disabled="!action.tooltip">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :data-has-tooltip="action.tooltip ? 'true' : 'false'"
            :data-tooltip="action.tooltip"
            v-on="on"
            v-bind="[action.attributes, attrs]"
            :key="index"
            :name="action.name"
            :id="action.id"
            @click="execute(action)"
            fab
            small
          >
            <v-icon v-if="action.attributesIcon" v-bind="action.attributesIcon">{{
              action.attributesIcon.icon
            }}</v-icon>
          </v-btn>
        </template>
        <span>{{ action.tooltip }}</span>
      </v-tooltip>
    </template>
  </v-speed-dial>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';
import devComponentMixin from '@/mixins/dev-component-mixin';
import actionDefault from '@/mixins/action-default';

export default {
  mixins: [devComponentMixin, actionDefault],

  data: () => ({
    fab: false,
    tooltip: 'left'
  }),

  props: {
    actions: { type: Array, required: true },
    mode: { type: String, required: true },
    page: { type: String, required: true },
    step: { type: Number, required: false },
    attributes: { type: Object, default: () => ({}), required: true },
    schema: { type: Object, default: () => ({}) }
  },

  events: {
    [HANDLERS.ACTION_DEFAULT]: 'executeActionDefault'
  },

  computed: {
    componentBehavior() {
      return this.attributes.openOnHover || this.attributes['open-on-hover'] ? 'hover' : 'click';
    },

    visibleActions() {
      if (Array.isArray(this.actions) && this.actions.length) {
        return this.actions.filter(action => action.visible || action.visible === undefined);
      }

      return []
    }
  },

  methods: {
    execute(action) {
      action.mode = this.mode;

      this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.page, step: this.step });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card__actions {
  .v-speed-dial {
    position: fixed;
    z-index: 100;
  }
  .v-btn--floating {
    position: relative;
  }
}

.v-speed-dial__list .v-btn {
  margin: 6px 8px;
}
</style>
